import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './Preloader.scss';

const normalizeCssColor = (value) => {
  const rawColor = typeof value === 'object'
    ? value?.rgb || value?.hex || value?.value
    : value;

  if (!rawColor) return null;

  const color = String(rawColor).trim();

  if (/^(#|rgb|hsl|var\()/i.test(color)) {
    return color;
  }

  if (/^\d+\s*,\s*\d+\s*,\s*\d+/.test(color)) {
    return `rgb(${color})`;
  }

  return color;
};

const setThemeColor = (name, colorData) => {
  const color = normalizeCssColor(colorData);
  if (color) {
    document.documentElement.style.setProperty(name, color);
  } else {
    document.documentElement.style.removeProperty(name);
  }
};

const themeColorFields = [
  ['--color-base', 'color_prin'],
  ['--color-base-hover', 'color_sec'],
  ['--color-text', 'color_text'],
  ['--color-text-selected', 'color_text_selected'],
  ['--color-title', 'color_title'],
  ['--color-nav2', 'color_nav2'],
  ['--color-nav-text2', 'color_nav_text2'],
  ['--color-price', 'color_price_text'],
  ['--color-button', 'color_button'],
  ['--color-button-text', 'color_button_text'],
  ['--brand-footer-bg', 'color_footer_background'],
  ['--brand-footer-title', 'color_footer_title'],
  ['--brand-footer-text', 'color_footer_text'],
  ['--brand-footer-bottom-bg', 'color_footer_bottom'],
];

const Preloader = (props) => {
  const { showPreloader,client } = props;
  useEffect(() => {
    document.body.style.overflow = (showPreloader) ? 'hidden' : 'auto';
  }, [showPreloader]);

  useEffect(() => {
    themeColorFields.forEach(([cssVariable, clientField]) => {
      setThemeColor(cssVariable, client?.[clientField]);
    });
  }, [client]);

  return (
    <div className={`preloader ${(showPreloader) ? '' : 'hide'}`} data-testid="preloader">
      {showPreloader &&
        <div className="preloader-content-container">
          <div className="loader-dots-container">
            <div className="loader-dot dot-1" />
            <div className="loader-dot dot-2" />
            <div className="loader-dot dot-3" />
          </div>
        </div>
      }
    </div>
  );
};

const mapStateToProps = (state) => ({
  showPreloader: state.app.showPreloader,
  client: state.app.client,
});

Preloader.propTypes = {
  showPreloader: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(Preloader);
